import { useNavigate, useParams } from 'react-router-dom';

import { SlackIntegration } from '@/components/admin/slack-integration';
import { useAuthStore } from '@/stores/auth-store';

function AccessDenied() {
  const navigate = useNavigate();

  return (
    <main id="main-content" className="max-w-4xl mx-auto px-4 py-6">
      <div className="text-center py-12">
        <svg
          className="mx-auto h-12 w-12 text-red-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
        <h1 className="mt-4 text-xl font-semibold text-content">Access Denied</h1>
        <p className="mt-2 text-sm text-content-secondary">
          You do not have permission to access the Slack Integration page. Only project administrators can manage this setting.
        </p>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="mt-6 inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 min-h-[44px]"
        >
          Go to Dashboard
        </button>
      </div>
    </main>
  );
}

export function ProjectSlackPage() {
  const { projectKey } = useParams<{ projectKey: string }>();
  const key = projectKey ?? '';
  const user = useAuthStore((state) => state.user);

  // Check admin access: global Admin OR project-level Admin
  const isAdmin =
    user?.role === 'Admin' ||
    (user?.projectRoles ?? []).some(
      (entry) => entry.project === key && entry.role === 'Admin'
    );

  if (!isAdmin) {
    return <AccessDenied />;
  }

  return <SlackIntegration projectKey={key} />;
}
